// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","mainSection":"G89183d","paddingElement":"G3559a9","orderedList":"Gac1a78","itemList":"Gba6792"};